import { type ApiResponse } from '@type/api'
import { axiosProxy } from '@utils/axios'

import { type Api } from './types'

const getList = () => axiosProxy.get<ApiResponse<Api.ListData>>('/fulfillment/options/federal-districts')

export const api = {
  getList,
}
